<div class="waiting-page">
    <section class="waiting-card">
        <header class="waiting-head">
            <p class="waiting-eyebrow">Sala d'attesa</p>
            <div class="waiting-service" [ngStyle]="setMyStyles()" *ngIf="ticketServiceRef">
                <mat-icon class="waiting-service__icon" *ngIf="ticketServiceRef.webIcon">{{ ticketServiceRef.webIcon }}</mat-icon>
                <span class="waiting-service__name">{{ ticketServiceRef.title | titlecase }}</span>
            </div>
        </header>

        <div class="waiting-body" *ngIf="slides && slides.length > 0; else noSlidesTemplate">
            <div class="waiting-status">
                <div class="waiting-queue" aria-live="polite">
                    <div class="waiting-queue__number" [ngClass]="{ next: ticketInWaiting < 2 }" *ngIf="ticketInWaiting > 0">
                        {{ ticketInWaiting }}
                    </div>
                    <p class="waiting-queue__label">Persone sono in coda prima di te</p>
                </div>

                <div class="waiting-ops">
                    <div class="waiting-op waiting-op--busy">
                        <mat-icon class="waiting-op__icon">headset_mic</mat-icon>
                        <span class="waiting-op__value">{{ operatorBusy }}</span>
                        <span class="waiting-op__label">Operatori occupati</span>
                    </div>
                    <div class="waiting-op waiting-op--free">
                        <mat-icon class="waiting-op__icon">how_to_reg</mat-icon>
                        <span class="waiting-op__value">{{ operatorFree }}</span>
                        <span class="waiting-op__label">Operatori liberi</span>
                    </div>
                </div>

                <p class="waiting-note" *ngIf="ticketInWaiting < 2">
                    <mat-icon class="waiting-note__icon">alarm</mat-icon>
                    <span>Grazie per la pazienza</span>
                </p>

                <div class="waiting-actions">
                    <button type="button" class="fo-btn fo-btn--danger fo-btn--block waiting-cancel" (click)="exit()">
                        Annulla la richiesta
                    </button>
                </div>
            </div>

            <div class="waiting-slides">
                <app-swiper [slides]="slides" [ticketID]="ticketID"></app-swiper>
            </div>
        </div>

        <ng-template #noSlidesTemplate>
            <div class="waiting-body waiting-body--solo">
                <div class="waiting-status">
                    <div class="waiting-queue" aria-live="polite">
                        <div class="waiting-queue__number" [ngClass]="{ next: ticketInWaiting < 2 }" *ngIf="ticketInWaiting > 0">
                            {{ ticketInWaiting }}
                        </div>
                        <p class="waiting-queue__label">Persone sono in coda prima di te</p>
                    </div>

                    <div class="waiting-ops">
                        <div class="waiting-op waiting-op--busy">
                            <mat-icon class="waiting-op__icon">headset_mic</mat-icon>
                            <span class="waiting-op__value">{{ operatorBusy }}</span>
                            <span class="waiting-op__label">Operatori occupati</span>
                        </div>
                        <div class="waiting-op waiting-op--free">
                            <mat-icon class="waiting-op__icon">how_to_reg</mat-icon>
                            <span class="waiting-op__value">{{ operatorFree }}</span>
                            <span class="waiting-op__label">Operatori liberi</span>
                        </div>
                    </div>

                    <p class="waiting-note" *ngIf="ticketInWaiting < 2">
                        <mat-icon class="waiting-note__icon">alarm</mat-icon>
                        <span>Grazie per la pazienza</span>
                    </p>

                    <div class="waiting-actions">
                        <button type="button" class="fo-btn fo-btn--danger fo-btn--block waiting-cancel" (click)="exit()">
                            Annulla la richiesta
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>
    </section>
</div>
